import { List } from 'linq.ts';
import React from 'react';
import { Icon, PrimaryButton, Stack, StackItem } from '../../fluent';
export class GenericDataTablePaginator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: this.props.currentPage || 1,
            totalPages: this.props.totalPages || 0,
            pages: this._getPages(this.props.currentPage || 1, this.props.totalPages || 0)
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.currentPage != this.props.currentPage || nextProps.totalPages != this.props.totalPages) {
            this.setState({
                currentPage: nextProps.currentPage || 1,
                totalPages: nextProps.totalPages || 0,
                pages: this._getPages(nextProps.currentPage || 1, nextProps.totalPages || 0)
            });
        }
    }
    _getPages(currentPage, totalPages) {
        if (totalPages === 0) {
            return [];
        }
        let pages = [];
        // Llenar páginas hacia atrás
        let pageNumber = currentPage;
        let counter = 0;
        while (counter <= 3 && pageNumber > 0) {
            pageNumber--;
            counter++;
            if (pageNumber > 0) {
                pages.push(pageNumber);
            }
        }
        // LLenar páginas hacia adelante
        pageNumber = currentPage;
        counter = 0;
        while (counter <= 3 && pageNumber <= totalPages) {
            pageNumber++;
            counter++;
            if (pageNumber <= totalPages) {
                pages.push(pageNumber);
            }
        }
        // Establecer página actual
        pages.push(currentPage);
        pages = new List(pages).OrderBy(o => o).ToArray();
        if (currentPage > 5) {
            const index2 = pages.indexOf(2);
            if (index2 > 0) {
                pages.splice(index2, 1);
                pages = [1, -1, ...pages];
            }
        }
        if (currentPage < totalPages - 5) {
            const index2 = pages.indexOf(totalPages - 1);
            pages.splice(index2, 1);
            pages = [...pages, -1, totalPages];
        }
        return pages;
    }
    render() {
        const stackTokens = { childrenGap: 0 };
        return React.createElement(Stack, { horizontal: true, horizontalAlign: "end", tokens: stackTokens },
            React.createElement(StackItem, { onClick: this._changePage.bind(this, 1) },
                React.createElement(Icon, { iconName: 'DoubleChevronLeftMed' })),
            React.createElement(StackItem, { onClick: this._changePage.bind(this, this.state.currentPage - 1) },
                React.createElement(Icon, { iconName: 'ChevronLeftMed' })),
            this.state.pages.map(o => {
                return o === -1
                    ? React.createElement(StackItem, null,
                        React.createElement("div", null, "..."))
                    : React.createElement(StackItem, { onClick: this._changePage.bind(this, o) }, o === this.state.currentPage ?
                        React.createElement(PrimaryButton, { style: { minWidth: 20 } }, o)
                        :
                            React.createElement("div", null, o));
            }),
            React.createElement(StackItem, { onClick: this._changePage.bind(this, this.state.currentPage + 1) },
                React.createElement(Icon, { iconName: 'ChevronRightMed' })),
            React.createElement(StackItem, { onClick: this._changePage.bind(this, this.state.totalPages) },
                React.createElement(Icon, { iconName: 'DoubleChevronLeftMedMirrored' })));
    }
    _changePage(pageNumber) {
        if (this.state.currentPage != pageNumber) {
            if (pageNumber > 0 && pageNumber <= this.state.totalPages) {
                this.setState({
                    currentPage: pageNumber,
                }, () => {
                    this.props.onChange(this.state.currentPage);
                });
            }
        }
    }
}
